module.exports = __webpack_public_path__ + "static/media/star.155478a9.svg";